// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import { paymentTypes } from '../../../../../../../../config/types';
import { CHARITY } from '../../../../../../../../config/constants';
import styles from './styles.js';

const MainLeftInfo = ({ classes, order }) => {
  const paymentType_description = 'PAYMENT TYPE - ';
  const paymentDetails_description = 'QUANTITY - ';
  const paymentType = paymentTypes[order.PaymentToCharity ? CHARITY : order.PaymentType];

  return (
    <div className={classes.mainInfoContainer}>
      <span>
        {paymentType_description}
        <span className={classes.boldFont}>
          {paymentType || 'NO PAYMENT TYPE'}
        </span>
      </span>
      <span>
        {paymentDetails_description}
        <span className={classes.boldFont}>{`${order.Quantity} books`}</span>
      </span>
    </div>
  );
};

MainLeftInfo.propTypes = {
  classes: PropTypes.object,
  order: PropTypes.object.isRequired,
};

MainLeftInfo.defaultProps = {
  classes: {},
};

export default withStyles(styles)(MainLeftInfo);
